import { render, staticRenderFns } from "./slidebar.html?vue&type=template&id=17cb877f&"
import script from "./Slidebar.vue?vue&type=script&lang=js&"
export * from "./Slidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports